import { useState } from 'react'

import { useOpenWindow } from '@krp/client-runtime'
import { JournalScreen, SYNC_WINDOWS, syncJournal } from '@krp/sync-ui'

import { queryState, useSyncSources } from './syncKit'

/** Журнал синхронизации (RP-SYN8): кто, что, откуда и куда применил; задача целиком открывается окном хода. */
export function SyncJournalBinding() {
  const openWindow = useOpenWindow()
  const { nameOf } = useSyncSources()
  const [page, setPage] = useState(1)
  const journal = syncJournal.useQuery({ page })
  const data = journal.data
  const state = queryState(journal, 'Не удалось получить журнал')
  return (
    <JournalScreen
      vm={{
        ...state,
        items: data?.items ?? [],
        nameOf,
        page,
        pages: data === undefined ? 1 : Math.max(1, Math.ceil(data.total / Math.max(1, data.pageSize))),
      }}
      actions={{ pageChanged: setPage, openJob: (jobId) => openWindow(SYNC_WINDOWS.job, { job: jobId }), reload: () => void journal.refetch() }}
    />
  )
}
